/**
 * Holds off a service-worker reload while the user is mid-edit.
 *
 * A new worker activating calls window.location.reload(), which throws away
 * anything typed into an open form. A counter rather than a boolean, because
 * more than one modal can be mounted and the first to close must not reopen
 * the gate for one still on screen.
 */
let holders = 0;

export function blockUpdates(): void {
  holders += 1;
}

export function allowUpdates(): void {
  holders = Math.max(0, holders - 1);
}

export function updatesBlocked(): boolean {
  return holders > 0;
}
